import { render, staticRenderFns } from "./GovVotingInfo.vue?vue&type=template&id=332f3b67&"
import script from "./GovVotingInfo.vue?vue&type=script&lang=js&"
export * from "./GovVotingInfo.vue?vue&type=script&lang=js&"
import style0 from "./GovVotingInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports